import { render, staticRenderFns } from "./SimpleMap.vue?vue&type=template&id=2a96992d&"
import script from "./SimpleMap.vue?vue&type=script&lang=js&"
export * from "./SimpleMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports